// src\themes\tolica\components\MainView.tsx
import WidgetsRender, { WidgetItem } from '@/components/main/widgets/WidgetsRender';
import BannerSlider from './BannerSlider';
import { SliderItemFrom } from '@/core/models/slider-model';
import StoryWidget from '@/components/main/widgets/StoryWidget';

type MainViewProps = {
    slides: SliderItemFrom[];
    widgets?: WidgetItem[];
};

export default async function MainView({ slides, widgets }: MainViewProps) {
    return (

        <div className="overflow-x-clip">
            <StoryWidget />
            <BannerSlider slides={slides} />

            <div className="grid grid-cols-12 gap-x-4 gap-y-11 md:gap-x-13 md:gap-y-13 lg:gap-y-18 lg:gap-x-18 mt-10 px-4 sm:px-6 lg:px-12 xl:px-20">
                <WidgetsRender widgets={widgets} isHome />
            </div>
        </div>
    );
}